<template>
     <div id="main-content">
        <div class="container-fluid">
            <div class="block-header">
                <bread-crumb :isDirectoryView="true"></bread-crumb>
            </div>
            <div class="row clearfix">
                <div class="col-lg-3 col-md-6 col-sm-12" v-for="(userDetail,index) in userState" :key="index" >
                    <div class="card">
                        <div class="body text-center">
                            <div class="chart easy-pie-chart-1" data-percent="75"> 
                                <span class="btn" @click="infoUser(userDetail.id)">
                                    <img :src="userDetail.profileImage? routeProfile + userDetail.profileImage : require('@/assets/userDefaultImg.jpg')" alt="user" class="rounded-circle"/>
                                </span>
                            </div>
                            <h6 class="cursor" @click="infoUser(userDetail.id)">
                                {{ userDetail.name }} {{ userDetail.surname }}
                            </h6>
                            <ul class="social-links list-unstyled">
                                <li><a title="facebook" href="javascript:void(0);"><i class="zmdi zmdi-facebook"></i></a></li>
                                <li><a title="twitter" href="javascript:void(0);"><i class="zmdi zmdi-twitter"></i></a></li>
                                <li><a title="instagram" href="javascript:void(0);"><i class="zmdi zmdi-instagram"></i></a></li>
                            </ul>
                            <small>{{ userDetail.roleUser }}</small>
                        </div>
                        <div class="body text-center">
                            <button @click="infoUser(userDetail.id)" type="button" class="btn btn-default mr-1"><i class="icon-info"></i></button>
                            <button @click="editUser(userDetail.id)" type="button" class="btn btn-default mr-1"><i class="icon-pencil"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Default Size -->
            <div id="addevent" v-if="showModal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h6 class="title" id="defaultModalLabel">Add Contact</h6>
                                </div>
                                <div class="modal-body">
                                    <div class="row clearfix">
                                        <div class="col-6">
                                            <div class="form-group">                                    
                                                <input type="text" class="form-control" placeholder="First Name">
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">                                   
                                                <input type="text" class="form-control" placeholder="Last Name">
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">                                    
                                                <input type="number" class="form-control" placeholder="Phone Number">
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">                                    
                                                <input type="text" class="form-control" placeholder="Enter Address">
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">                                            
                                                <input type="file" class="form-control-file" id="exampleInputFile" aria-describedby="fileHelp">
                                                <small id="fileHelp" class="form-text text-muted">This is some placeholder block-level help text for the above input. It's a bit lighter and easily wraps to a new line.</small>
                                            </div>
                                            <hr>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">                                    
                                                <input type="text" class="form-control" placeholder="Facebook">
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">                                   
                                                <input type="text" class="form-control" placeholder="Twitter">
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">                                    
                                                <input type="text" class="form-control" placeholder="Linkedin">
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">                                    
                                                <input type="text" class="form-control" placeholder="instagram">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-primary">Add</button>
                                    <button type="button" class="btn btn-secondary" @click="showModal = false">CLOSE</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from '@/components/BreadCrumb';
export default {
    name:'ContactGrideComponent',
    components: {
       BreadCrumb,
    },data (){
        return{
            showModal: false,
            routeProfile: '',
        }
    },
    computed: {
        userState(){
            const userList = this.$store.getters['userStore/getUserList'];
            return userList ? userList : '' ;
        },
    },
    watch:{
        userState(){
            this.routeProfile = process.env.VUE_APP_BACK_BASE + 'media/img/profiles/';
        }
    },
    created() {
        this.getUserList();
    },
    
    methods: {
        openModal: function () {
          this.showModal = true
        },
        getUserList() {
          this.$store.dispatch('userStore/getMainDataUserAction');
        },
        infoUser(user){
          this.$router.push(`/app/app-directory/info/${user}`);
        },
        editUser(user){
          this.$router.push(`/app/app-directory/${user}`);
        }
    }   
}
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: top;
}

.cursor {
    cursor: pointer;
}
</style>